<template>
  <div>
    <VSectionBar
      id="guarantee"
      message="サービス保証"
    />
    <v-container
      class=main--text
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=6>
          <v-card>
            <v-img
              :src="motherAndDaughterImage"/>
            <v-container
              fluid>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h3>受講開始から１ヶ月間について</h3>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h3>授業内容にご満足いただけなかった場合</h3>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto
                  class="red--text">
                  <h2>授業料を全額返金します</h2>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import MotherAndDaughterImage from '@/assets/img/mother_and_daughter.jpg'

export default {
  name: 'VFreeTrial',
  components: {
    VSectionBar
  },
  data: () => {
    return {
      motherAndDaughterImage: MotherAndDaughterImage
    }
  }
}
</script>